import styled from 'styled-components';
import Theme from '../../../../styles/models/theme';

export const Container = styled.button<{
  backgroundColor?: string;
  disabled?: boolean;
  size: number;
  theme: Theme;
}>`
  background-color: ${({backgroundColor, theme}) =>
    backgroundColor || theme.primary};
  height: ${({size}) => `${size}px`};
  width: ${({size}) => `${size}px`};
  border-radius: ${({size}) => `${size / 2}px`};
  opacity: ${({disabled}) => (disabled ? 0.5 : 1)};
  border-width: 0px;
  &:active {
    opacity: ${({disabled}) => (disabled ? 0.5 : 0.8)};
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.img<{size?: number}>`
  width: ${({size}) => (size ? `${size}px` : '40px')};
  height: ${({size}) => (size ? `${size}px` : '40px')};
`;
